"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkListFragment = void 0;
var _fetching = require("@ori/fetching");
const linkListFragment = exports.linkListFragment = (0, _fetching.gql)`
  fragment LinkList on EditorialLinkList {
    __typename
    id
    title
    linkItems {
      __typename
      downloadable
      title
      link {
        __typename
        id
        relativeUrl
        title
        type
        appLink {
          __typename
          link
          deepLink
        }
      }
    }
  }
`;
